import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React from "react";
import { ColumnLayout } from "../components/Layout/ColumnLayout";
import { Page } from "./Page";

interface BreadcrumbItem {
    text: string;
    onClick?: () => void;
}

interface ResourceListPageProps {
    title: string;
    breadcrumbItems: BreadcrumbItem[];
    primaryButton: React.ReactNode;
    secondaryButton?: React.ReactNode;
    children: React.ReactNode;
}

export const ResourceListPage = ({
    title,
    breadcrumbItems,
    primaryButton,
    secondaryButton,
    children,
}: ResourceListPageProps) => {
    return (
        <Page title={title}>
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb className="mr-auto">
                        {breadcrumbItems.map((item) => (
                            <Breadcrumb.Item key={item.text} onClick={item.onClick}>
                                {item.text}
                            </Breadcrumb.Item>
                        ))}
                    </HeaderToolbar.Breadcrumb>
                    {secondaryButton}
                    {primaryButton}
                </HeaderToolbar>
                <ColumnLayout.Fill>{children}</ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
